import { render, staticRenderFns } from "./ShowPrivacy.vue?vue&type=template&id=23d8f310"
import script from "./ShowPrivacy.vue?vue&type=script&lang=js"
export * from "./ShowPrivacy.vue?vue&type=script&lang=js"
import style0 from "./ShowPrivacy.vue?vue&type=style&index=0&id=23d8f310&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports